import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import CookieBanner from "@/components/site/CookieBanner";
import Home from "./pages/Home";
import OmOss from "./pages/OmOss";
import Tjanster from "./pages/Tjanster";
import Medarbetare from "./pages/Medarbetare";
import Nyheter from "./pages/Nyheter";
import NyhetDetalj from "./pages/NyhetDetalj";
import Kontakt from "./pages/Kontakt";
import Rattshjalp from "./pages/Rattshjalp";
import Paket from "./pages/Paket";
import NotariusPublicus from "./pages/NotariusPublicus";
import Integritetspolicy from "./pages/Integritetspolicy";
import AllmannaVillkor from "./pages/AllmannaVillkor";
import Klagomal from "./pages/Klagomal";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Portal from "./pages/Portal";
import CaseDetail from "./pages/CaseDetail";
import Admin from "./pages/Admin";
import Resurser from "./pages/Resurser";
import GlomtLosenord from "./pages/GlomtLosenord";
import AterstallLosenord from "./pages/AterstallLosenord";
import Vardnadstvist from "./pages/Vardnadstvist";
import LandingPage from "./pages/LandingPage";
import Orter from "./pages/Orter";
import CityPage from "./pages/CityPage";
import SiteLayout from "./components/site/SiteLayout";
import ProtectedRoute from "./components/site/ProtectedRoute";

function AppRouter() {
    const location = useLocation();
    // CRITICAL: handle session_id fragment synchronously before any protected route renders
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/om-oss" element={<OmOss />} />
                <Route path="/tjanster" element={<Tjanster />} />
                <Route path="/medarbetare" element={<Medarbetare />} />
                <Route path="/nyheter" element={<Nyheter />} />
                <Route path="/nyheter/:slug" element={<NyhetDetalj />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/rattshjalp" element={<Rattshjalp />} />
                <Route path="/paket" element={<Paket />} />
                <Route path="/notarius-publicus" element={<NotariusPublicus />} />
                <Route path="/vardnadstvist" element={<Vardnadstvist />} />
                <Route path="/bodelning" element={<LandingPage />} />
                <Route path="/testamente" element={<LandingPage />} />
                <Route path="/brottmal" element={<LandingPage />} />
                <Route path="/arbetsratt-uppsagning" element={<LandingPage />} />
                <Route path="/bostadsratt-tvist" element={<LandingPage />} />
                <Route path="/arvsskifte" element={<LandingPage />} />
                <Route path="/bouppteckning" element={<LandingPage />} />
                <Route path="/framtidsfullmakt" element={<LandingPage />} />
                <Route path="/samboavtal" element={<LandingPage />} />
                <Route path="/aktenskapsforord" element={<LandingPage />} />
                <Route path="/orter" element={<Orter />} />
                <Route path="/jurist-stockholm" element={<CityPage />} />
                <Route path="/jurist-goteborg" element={<CityPage />} />
                <Route path="/jurist-malmo" element={<CityPage />} />
                <Route path="/jurist-uppsala" element={<CityPage />} />
                <Route path="/jurist-jonkoping" element={<CityPage />} />
                <Route path="/jurist-herrljunga" element={<CityPage />} />
                <Route path="/integritetspolicy" element={<Integritetspolicy />} />
                <Route path="/allmanna-villkor" element={<AllmannaVillkor />} />
                <Route path="/klagomal" element={<Klagomal />} />
                <Route path="/logga-in" element={<Login />} />
                <Route path="/glomt-losenord" element={<GlomtLosenord />} />
                <Route path="/aterstall-losenord/:token" element={<AterstallLosenord />} />
                <Route
                    path="/portal"
                    element={
                        <ProtectedRoute>
                            <Portal />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/portal/arende/:id"
                    element={
                        <ProtectedRoute>
                            <CaseDetail />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/admin"
                    element={
                        <ProtectedRoute adminOnly>
                            <Admin />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/resurser"
                    element={
                        <ProtectedRoute adminOnly>
                            <Resurser />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <CookieBanner />
                </AuthProvider>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-center"
                richColors
                toastOptions={{
                    style: {
                        background: "#111113",
                        color: "#F4F4F5",
                        border: "1px solid rgba(196, 169, 119, 0.35)",
                        borderRadius: "2px",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
